import "./footer.css";

const Footer = () => (
  <footer className="footer">
    <a
      href="https://erxcc.dev/"
      className="link footer__link"
    >
      Copyright &copy; Eric 2024
    </a>
  </footer>
);

export default Footer;
